import { render, staticRenderFns } from "./NewFooter.vue?vue&type=template&id=955f91ee&scoped=true"
import script from "./NewFooter.vue?vue&type=script&lang=js"
export * from "./NewFooter.vue?vue&type=script&lang=js"
import style0 from "./NewFooter.vue?vue&type=style&index=0&id=955f91ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955f91ee",
  null
  
)

export default component.exports